import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';

import Grades from 'src/components/ui/Grades';
import LinksDotted from 'src/components/ui/LinksDotted';
import ButtonClipboard from 'src/components/ui/ButtonClipboard';

import { SIDE_OPTION_TYPES as TYPES } from './constants';

const SideOption = ({ type = TYPES.text, label, payload, valueClipboard }) => {
	let value;
	switch (type) {
		case TYPES.text:
			value = (
				<Typography {...payload.typography}>{payload.value}</Typography>
			);
			break;
		case TYPES.link:
			value = <LinksDotted {...payload} />;
			break;
		case TYPES.rating:
			value = (
				<Stack spacing={0.25} direction="row" alignItems="center">
					<Typography>{payload.value}</Typography>
					<Rating size="small" readOnly {...payload} />
				</Stack>
			);
			break;
		case TYPES.grade:
			value = <Grades {...payload} />;
			break;
	}

	return (
		<Stack gap={0.5} direction="row" alignItems="baseline">
			{label && (
				<Typography
					color="secondary"
					sx={{
						flex: '0 0 27%',
						minWidth: 'max-content',
						whiteSpace: 'nowrap',
						fontSize: '12px',
					}}
				>
					{label}
				</Typography>
			)}
			<Stack
				direction="row"
				alignItems="center"
				sx={{ minWidth: 0, flex: 1 }}
			>
				{value}
				{valueClipboard && <ButtonClipboard value={valueClipboard} />}
			</Stack>
		</Stack>
	);
};

SideOption.propTypes = {
	type: PropTypes.oneOf(Object.values(TYPES)),
	label: PropTypes.string,
	payload: PropTypes.oneOfType([
		PropTypes.shape({
			// type === 'text'
			value: PropTypes.string,
			typography: PropTypes.shape(Typography.propTypes),
		}),
		PropTypes.shape(LinksDotted.propTypes), // type === 'link'
		PropTypes.shape(Rating.propTypes), // type === 'rating'
		PropTypes.shape(Grades.propTypes), // type === 'grade'
	]),
	valueClipboard: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default SideOption;
